<script lang="ts">
import type { PropType } from '@mimir/web/compat/vueCompat';
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VTabs } from 'vuetify/lib';

export default defineComponent({
  name: 'MTabs',
  components: {
    VTabs,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },
    customClass: {
      type: Array as PropType<string[]>,
      default: () => [''],
    },
    overrideArrowBehavior: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showArrows: false,
    };
  },
  mounted() {
    if (this.overrideArrowBehavior)
      this.manuallyRecomputeArrows();
  },
  updated() {
    if (this.overrideArrowBehavior)
      this.manuallyRecomputeArrows();
  },
  methods: {
    onChange(ev: string) {
      this.$emit('change', ev);
      this.$emit('input', ev);
    },
    manuallyRecomputeArrows() {
      const wrapper = this.$el.querySelector('.v-slide-group__wrapper');
      const content = this.$el.querySelector('.v-slide-group__content');
      if (!wrapper || !content)
        return;
      if (wrapper.clientWidth < content.clientWidth) {
        this.showArrows = true;
      } else {
        this.showArrows = false;
      }
    },
  },
});
</script>

<template>
  <VTabs
    center-active
    :class="['m-tabs', ...customClass]"
    :value="value"
    :show-arrows="overrideArrowBehavior ? showArrows : true"
    v-bind="$attrs"
    height="33"
    :hide-slider="true"
    v-on="$listeners"
    @change="onChange"
  >
    <slot />
  </VTabs>
</template>

<style lang="stylus">
  .m-tabs &
    .v-slide-group__next,
    .v-slide-group__prev
      flex: 0 1 24px !important
      min-width: 24px !important
    .v-tabs-bar
      border-radius: 8px
      height: 32px !important
      width: fit-content
      border: 1px solid var(--v-dimmed-darken2)
      &.theme--light
        border: 1px solid var(--v-dimmed-lighten2)
    .v-tabs-bar__content
      align-items: center
      gap: 1px
      padding: 0px 1px
      border: 0px
    .v-tab--active
      background: var(--v-primary-base)
      color: var(--v-secondary-base) !important
      .theme--light &
        background: var(--v-primary-lighten4) !important
        color: var(--v-primary-darken4) !important
    .v-tab, .v-tab:hover:before, .v-tab:focus:before
      letter-spacing: 0
      border-radius: 6px
      height: 28px
      text-transform: none !important
      font-weight: 400
  .v-tab
    text-transform: none !important

  .v-tab .v-icon
    font-size: 18px !important // Icons in v-tab should be small
    margin-right: 8px !important // Space between text and icon

  .quick-preview-tab, .full-width-tab
    .v-tabs-bar
      width: auto
  .v-tabs:not(.v-tabs--vertical) .v-tabs-bar
    background: transparent !important
    position: -webkit-sticky
    position: sticky
    top: 0rem
    z-index: 2
    backdrop-filter: blur(8px)
    margin-top: 2px
  .v-tabs-items
    background: transparent !important
</style>
